App.Pages.Profile = class Profile extends PF.Page {

    static get options() {
        return {
            rights: {
                user: true
            },
            path: '/profile',
            nameRu: 'Профиль',
        };
    }

    static get template() {
        // language=HTML
        return `
			<div id="Profile" class="page stretch">

				<div class="page-content" pf="pageContent">

                    <div class="page-header">
                        <h3>Профиль</h3>
                    </div>

					<div class="stretch-block">
						<form class="card" pf="profile">
							<input type="text" class="phone" placeholder="Номер телефона" disabled pf="phone">

							<input type="text" placeholder="Фамилия" pf="lname">

							<input type="text" placeholder="Имя" pf="fname">

							<input type="text" placeholder="Отчество" pf="mname">

							
								<button href="#" class="button button-fill" pf="submit">Сохранить</button>
							

<!--							<div class="row" style="text-align: center">-->
<!--								<div class="col-50">-->
<!--									<a href="/change-phone" class="">Изменить телефон</a>-->
<!--								</div>-->
<!--								<div class="col-50">-->
<!--									<a href="/change-pass" class="">Изменить пароль</a>-->
<!--								</div>-->
<!--							</div>-->

						</form>


						<div class="block">
							<a href="/change-pass" class="button button-raised" >Изменить пароль</a><br/>
							<a href="#" class="button button-raised" pf="signOut">Выход</a>
						</div>

					</div>
				</div>
			</div>

		`;
    }

    init() {
        super.init();

        if (app !== undefined) {
            if (app.fireNotice !== undefined) {
                app.fireNotice.askSubscribe();
            } else {
                app.fireNotice = new App.FireNotice();
            }
        }


        this.form = new PF.Form({
            dom: {
                element: this.dom.profile,
            },
            modelConfig: {
                represent: 'user/profile',
            },
            fieldsConfig: {
                phone: {
                    class: PF.Field.Phone,
                },
                lname: {
                    class: PF.Field.String,
                },
                fname: {
                    class: PF.Field.String,
                },
                mname: {
                    class: PF.Field.String,
                },
            }
        });

        this.dom.signOut.on('click', () => app.signOut());

    }

};